var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaleTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 31,
    viewBox: "0 0 116 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.452 14.3428C115.452 6.67627 109.286 0.435715 101.62 0.343775L72.9556 0L33.9556 0L11.4556 0L12.7693 0.328536C18.9838 1.88268 23.2425 7.60067 22.9517 14L22.9517 20C22.9517 25.8043 27.657 30.5097 33.4613 30.5097L115.452 30.5097L115.452 14.3428Z",
    fill: "url(#paint0_linear_9996_80256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9154 8H0C1.48075 3.36017 5.82682 0 10.9577 0C16.0886 0 20.4346 3.36017 21.9154 8Z",
    fill: "#F55005"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9996_80256",
    x1: 356.951,
    y1: 26.1835,
    x2: 27.4859,
    y2: 26.1835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF872E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517977,
    stopColor: "#FD4E03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF882E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleTag);
export default __webpack_public_path__ + "static/media/sale-tag.2f45007c7f547bdb1c8703c39c96f057.svg";
export { ForwardRef as ReactComponent };